import { OneButtonModalFooterProps } from "types/modals";
import { Button, ButtonType } from "components/common/Button.component";

export const OneButtonModalFooter = ({
    tabIndex,
    enabled,
    callback,
    text,
    loopFocus,
    buttonRef,
}: OneButtonModalFooterProps) => (
    <div className="ga-modal__actions">
        <Button
            ref={buttonRef}
            type={ButtonType.SECONDARY}
            text={text}
            onClick={callback}
            disabled={!enabled}
            onBlur={loopFocus}
            tabIndex={tabIndex + 1}
        />
    </div>
);

export default OneButtonModalFooter;